import init from "../base/init"

init(() => {
  const btnEl = document.getElementById("my_lexnova_side_menu_btn")

  if (!btnEl) return

  btnEl.addEventListener("click", () => {
    document.querySelector('.sidebar-user').classList.toggle('--active')
  })
})
